const calculateSavePercentage = (
  pricePerCheck: number,
  biggestPricePerCheck: number,
  basePrice: number,
): number => {
  if (!basePrice) return 0;
  if (pricePerCheck >= biggestPricePerCheck) return 0;
  return Number((100 - (pricePerCheck / basePrice) * 100).toFixed(0));
};

export default calculateSavePercentage;
